import { c as _c } from "react/compiler-runtime";
import { getCountryNameFromCode } from '@onefootprint/core';
import { IcoShieldFlash40 } from '@onefootprint/icons';
import { markContinueOnMobile, setIdv2StoreData } from '@onefootprint/idv2';
import { DocumentRequestKind, DocumentUploadSettings } from '@onefootprint/types';
import { Divider, LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { NavigationHeader } from '@/idv/components';
import FadeInContainer from '../../../components/fade-in-container';
import IdDocPhotoButtons from '../../../components/id-doc-photo-buttons';
import PromptWithGuidelines from '../../../components/prompt-with-guidelines';
import type { CaptureKind } from '../../../types';
import { useNonIdDocMachine } from '../../components/machine-provider';
import useGuidelines from './hooks/use-guidelines';
import useTitleAndDescription from './hooks/use-title-and-description';
const DocumentPrompt = () => {
  const $ = _c(33);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.non-id-doc.pages.document-prompt"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const [state, send] = useNonIdDocMachine();
  const {
    device,
    hasBadConnectivity,
    requirement,
    obConfigSupportedCountries,
    config,
    allowPdf
  } = state.context;
  const hasPreferUploadSettings = requirement.uploadSettings === DocumentUploadSettings.preferUpload;
  const isMobile = device.type === "mobile";
  const {
    kind: documentRequestKind
  } = requirement.config;
  let t1;
  if ($[1] !== config || $[2] !== documentRequestKind) {
    t1 = {
      docKind: documentRequestKind,
      config
    };
    $[1] = config;
    $[2] = documentRequestKind;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const guidelines = useGuidelines(t1);
  const {
    title,
    description
  } = useTitleAndDescription(requirement.config);
  let alertMessage;
  if (obConfigSupportedCountries && obConfigSupportedCountries.length === 1 && documentRequestKind === DocumentRequestKind.ProofOfAddress) {
    let t2;
    if ($[4] !== obConfigSupportedCountries[0] || $[5] !== t) {
      t2 = t(_temp, {
        country: getCountryNameFromCode(obConfigSupportedCountries[0])
      });
      $[4] = obConfigSupportedCountries[0];
      $[5] = t;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    alertMessage = t2;
  }
  let t2;
  if ($[7] !== send) {
    t2 = payload => {
      send({
        type: "receivedDocument",
        payload
      });
    };
    $[7] = send;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleComplete = t2;
  const handleContinueOnMobile = _temp2;
  let t3;
  if ($[9] !== send) {
    t3 = () => {
      send({
        type: "startImageCapture"
      });
    };
    $[9] = send;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleTakePhoto = t3;
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== alertMessage || $[13] !== description || $[14] !== guidelines || $[15] !== title) {
    t5 = <PromptWithGuidelines title={title} icon={IcoShieldFlash40} description={description} guidelines={guidelines} alertMessage={alertMessage} />;
    $[12] = alertMessage;
    $[13] = description;
    $[14] = guidelines;
    $[15] = title;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = documentRequestKind === DocumentRequestKind.Custom ? hasPreferUploadSettings : documentRequestKind !== DocumentRequestKind.ProofOfSsn;
  const t7 = !isMobile;
  let t8;
  if ($[17] !== allowPdf || $[18] !== handleComplete || $[19] !== handleTakePhoto || $[20] !== hasBadConnectivity || $[21] !== t6 || $[22] !== t7) {
    t8 = <IdDocPhotoButtons onComplete={handleComplete} uploadFirst={t6} allowPdf={allowPdf} hideCaptureButton={t7} onTakePhoto={handleTakePhoto} hasBadConnectivity={hasBadConnectivity} />;
    $[17] = allowPdf;
    $[18] = handleComplete;
    $[19] = handleTakePhoto;
    $[20] = hasBadConnectivity;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t5 || $[25] !== t8) {
    t9 = <div className="h-full flex flex-col gap-6 items-center justify-center">{t5}{t8}</div>;
    $[24] = t5;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== isMobile || $[28] !== t) {
    t10 = isMobile ? null : <div className="flex flex-col gap-4 items-center"><Divider variant="secondary" className="pt-6 w-[calc(100%+64px)]" /><LinkButton onClick={handleContinueOnMobile}>{t(_temp3)}</LinkButton></div>;
    $[27] = isMobile;
    $[28] = t;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t9) {
    t11 = <FadeInContainer>{t4}{t9}{t10}</FadeInContainer>;
    $[30] = t10;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
export default DocumentPrompt;
function _temp($) {
  return $["single-country-alert"];
}
function _temp2() {
  markContinueOnMobile();
  setIdv2StoreData({
    relayToIDV2: true
  });
}
function _temp3($_0) {
  return $_0["continue-on-mobile"];
}